export const formatValue = (value: string) => {
  const numericValue = Number(value);
  return numericValue.toString().replace(/\.0+$/, '');
};
